/** Where one declared canvas is reached, derived from the declaration and never from its kind. */

import { canvasAddress, deviceCanvasAddress, spaceAddress } from "@/lib/env";

import type { NamedCanvas } from "../types";

/** One address that reaches a canvas, and who it is for. */
export interface CanvasAddress {
  /** The role that opens it, or what kind of holder pastes it. Never a product name. */
  label: string;
  value: string;
}

/** Every address that reaches this canvas. A machine-screen canvas has none. */
export function canvasAddresses(canvas: NamedCanvas, joinCode: string): CanvasAddress[] {
  if (canvas.on_machine_screen === true) return [];
  if (canvas.attach === "paired") {
    return [{ label: "a paired device", value: deviceCanvasAddress(canvas.kind) }];
  }
  const roles = canvas.roles ?? [];
  if (roles.length === 0) return [{ label: "every role", value: spaceAddress(joinCode) }];
  return roles.map((role) => ({ label: role, value: canvasAddress(joinCode, role) }));
}

/** Whether this declaration answers to a kind, through its own name or one of its aliases. */
export function answersTo(canvas: NamedCanvas, kind: string): boolean {
  return canvas.kind === kind || (canvas.aliases ?? []).includes(kind);
}
